import moment from 'moment';

export function parseMarketingMetricDate(row) {
  const date = row?.date;
  if (!date) {
    return null;
  }
  if (typeof date === 'string') {
    const parsed = moment(date);
    return parsed.isValid() ? parsed : null;
  }
  if (date.year == null || date.month == null) {
    return null;
  }
  return moment({
    year: date.year,
    month: date.month - 1,
    day: date.day || 1,
  });
}

export function marketingSpendAmountForRow(row, isCurrentMonth) {
  const actual =
    Number(row.actual_marketing_spend ?? row.actualMarketingSpend) || 0;
  const predicted =
    Number(row.predicted_marketing_spend ?? row.predictedMarketingSpend) || 0;

  if (isCurrentMonth) {
    return actual + predicted;
  }
  if (actual > 0) {
    return actual;
  }
  return predicted;
}

export function resolveMarketingSpendForMonth(marketingMonthlySpendData, monthKey) {
  if (!marketingMonthlySpendData?.length || !monthKey) {
    return null;
  }

  const isCurrentMonth = moment(`${monthKey}-01`).isSame(moment(), 'month');

  for (const row of marketingMonthlySpendData) {
    const rowDate = parseMarketingMetricDate(row);
    if (!rowDate?.isValid() || rowDate.format('YYYY-MM') !== monthKey) {
      continue;
    }
    return marketingSpendAmountForRow(row, isCurrentMonth);
  }

  return null;
}
